"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var Title = function Title(props) {
  var content = props.content,
    maxLines = props.maxLines,
    className = props.className,
    _props$block = props.block,
    block = _props$block === void 0 ? true : _props$block;
  var Wrapper = block ? 'div' : 'span';
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('title'), className, (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)("title-ellipsis-".concat(maxLines)), maxLines))
  }, content);
};
exports.Title = Title;